<template>
  <v-card v-if="true">
    <v-toolbar color="color1 color1Text--text">
      <v-toolbar-title>
        What's Next?
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-list>
        <template v-for="m in futureMatches">
          <v-list-item :key="`l-${m.map}`" lines="three">
            <v-list-item-content>
              <v-list-item-title>
                {{ m.map }}<v-icon class="mx-2" small>fas fa-arrow-alt-right</v-icon>{{ m.round.name }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="m.what">{{m.what}}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="m.props.length > 0">{{m.props.join(' | ')}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn color="color3 color3Text--text" fab :to="m.to">
                <v-icon>fas fa-caret-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="`d-${m.map}`"></v-divider>
        </template>
      </v-list>
    </v-card-text>
    <v-card-actions v-if="false">
      <v-btn color="success" @click.stop="onTestClick">Test</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { ordinal } from '@/Filters'
import { firstBy } from 'thenby'
import { createMap } from '@/helpers/CaptureSeedMapper'

export default {
  props: ['division', 'round', 'pool'],
  data () {
    return {
      currentMap: null
    }
  },
  computed: {
    ...mapGetters(['tournament']),
    futureRounds () {
      return this.tournament.publicRounds.filter(round =>
        round.teamSelectors.length === 1 && round.teamSelectors.some(selector => selector.fromRoundId === this.round.id)
      )
    },
    show () {
      return this.futureRounds.length > 0 && this.futureRounds.findIndex(r => r.poolPlay) === -1
    },
    mapStrings () {
      return Array.from({ length: this.pool.teams.length }, (_, i) => ({ finish: i + 1, text: `${ordinal(i + 1)} Place Pool ${this.pool.name || this.pool.number}` }))
    },
    futureMatches () {
      const possibleMatches = this.futureRounds
        .map(r => r.allMatches.filter(f => !f.isBye).map(m => ({ round: r, match: m, maps: [m.homeMap, m.awayMap, m.refMap].filter(Boolean) })))
        .flat()
        .sort(
          firstBy((a, b) => { return a.round.number - b.round.number })
            .thenBy((a, b) => { return a.match.unix - b.match.unix })
            .thenBy((a, b) => { return a.match.number - b.match.number })
        )

      const result = this.mapStrings.map(str => {
        const m = possibleMatches.find(f => f.maps.includes(str.text))
        if (!m) {
          return this.getFuturePoolRound(str)
        }
        const props = []
        if (m.match.refMap === str.text) {
          props.push('Ref')
        }
        if (m.match.homeMap === str.text || m.match.awayMap === str.text) {
          props.push('Play')
        }
        // m.when && !r.hideTimes && props.push(m.when.format('ddd LT'))
        m.match.startTime && props.push(m.match.startTime.format('ddd LT'))
        m.match.court && props.push(`Court ${m.match.court}`)

        return {
          map: str.text,
          round: m.round,
          to: m.round.poolPlay ? { name: 'pool-sheet', params: { poolId: m.match.poolId, dayId: m.round.id } } : { name: 'bracket-home', params: { dayId: m.round.id } },
          what: m.match.bracketId ? 'Bracket Play' : m.match.poolId ? 'Pool Play' : null,
          props: props
        }
      }).filter(Boolean)

      return result
    }
  },
  methods: {
    onTestClick () {
      console.log(this.futureRounds)
    },
    getFuturePoolRound (mapObj) {
      if (!this.currentMap) this.currentMap = createMap(this.round.flight.pools, [], (this.round.flight.powerPools || 0))

      const round = this.futureRounds.find(r => {
        const s = r.teamSelectors[0]
        if (!(s.seedStyle.startsWith('CAPTURE') || s.seedStyle !== 'MAPPED')) return false

        if (s.seedStyle.startsWith('CAPTURE')) {
          switch (s.type) {
            case 'ALL':
              return true
            case 'TOP_N_EACH':
              return mapObj.finish <= s.n
            case 'NOT_TOP_N_EACH':
              return mapObj.finish > s.n
            case 'NOT_TAKE':
            case 'TAKE': {
              const pools = s.advancedN.split(',').map(m => +m)
              const n = pools[this.pool.number]
              return s.type === 'TAKE' ? mapObj.finish <= n : mapObj.finish > n
            }
            case 'POOL_FINISH':
              return mapObj.finish === s.n
            default:
              break
          }
          const map = s.exclude ? createMap(this.round.flight.pools, s.teamIds.split(',').map(m => +m), (this.round.flight.powerPools || 0)) : this.currentMap
          const seedObj = map.find(f => f.poolNumber === this.pool.number && f.poolFinish === mapObj.finish)
          if (!seedObj) return false
          switch (s.type) {
            case 'RANGE':
              return seedObj.seed >= s.startSeed && seedObj.seed <= s.endSeed
            case 'SELECT': {
              const seeds = s.seeds.split(',').map(m => +m)
              return seeds.includes(seedObj.seed)
            }
            default:
              return false
          }
        } else if (s.seedStyle !== 'MAPPED') {
          const mapped = s.map.split('|')
          return mapped.includes(`${this.pool.number}-${mapObj.finish}`)
        }
        return false
      })

      if (round) {
        const props = []
        round.startTime && props.push(round.startTime.format('ddd LT'))
        return {
          map: mapObj.text,
          round: round,
          to: { name: 'pools-home', params: { dayId: round.id } },
          what: 'Pool Play',
          props: props
        }
      }

      return false
    }
  }
}
</script>
